import { render, staticRenderFns } from "./SeafarerDashboardApplicationTable.vue?vue&type=template&id=67ed4aeb&scoped=true"
import script from "./SeafarerDashboardApplicationTable.vue?vue&type=script&lang=ts"
export * from "./SeafarerDashboardApplicationTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ed4aeb",
  null
  
)

export default component.exports